import { GoldSilverInventorySelectedTab, ReportsGoldInventorySelectedTab, SilverInventorySelectedTab } from '~types/redux/state';
import { FundTypeEnum, GoldTypeEnum, ModuleEnum, PermissionsEnum } from './enums';

const {
    Create,
    View,
    Edit,
    Delete: _Delete,
} = PermissionsEnum;

export const NavigationConstants = {
    homePage: '/',
    loginPage: '/login',
};

export const ErrorMessages = {
    GenericError: 'Something went wrong. Please try again later',
    GenericRequiredFieldNotFilledIn: 'Required field not filled in!',
    GenericRequiredFieldNotProvided: 'Required field not provided!',
    GenericTimeoutError: 'Connection timed out. Please try again later',

    //Login
    LoginGenericError: 'Login failed. Please try again later',
    LoginMissingUserIdAndPasswordError: 'User ID and password is required',
    LoginMissingUserIdError: 'User ID is required',
    LoginMissingPasswordError: 'Password is required',

    // Component
    MissingRequiredPropertiesError: 'Component has missing required properties',

    // Filters
    FilterInvalidStatusError: 'Invalid status filter',

    // Gold Transactions
    GoldTypeUndefinedError: 'Gold type is not defined',
    GoldCreateTransactionError: 'Failed to create gold transaction!',

    // Customer
    CustomerHasNoInventoryError: 'Customer has no inventory',
};

export const SuccessMessages = {
    // Login
    LoginSuccess: 'Successfully logged in!',

    // Logout
    LogoutSuccess: 'Successfully logged out!',

    // Gold Transactions
    GoldCreateBuyTransactionSuccess: 'Successfully created buy gold transaction and submitted for approval!',
    GoldCreateSellTransactionSuccess: 'Successfully created sell gold transaction and submitted for approval!',
    GoldCancelTransactionSuccess: 'Successfully cancelled transaction!',

    // Gold Inventory
    GoldCreateInventorySuccess: 'Successfully created new inventory!',
    GoldTransferInventorySuccess: 'Successfully created transfer gold inventory approval!',

    // Inventory Transaction
    InventoryTransactionCancelTransactionSuccess: 'Successfully cancelled transaction!',

    //Discount
    DiscountDetailsUpdateSuccess: 'Successfully created update discount approval!',
    DiscountUpdateApprovalSuccess: 'Successfully approved discount!',
    DiscountUpdateRejectSuccess: 'Successfully rejected discount!',

    // Customer
    CustomerCreateNewCustomerSuccess: 'Successfully created new customer!',
    CustomerEditCustomerDetailsSuccess: 'Successfully updated customer details!',
    CustomerDeleteCustomerSuccess: 'Successfully deleted customer!',
    CustomerReleaseEarmarkSuccess: 'Successfully release earmark!',

    // Collateral
    CustomerCreateCollateralSuccess: 'Successfully created collateral!',
    CustomerCollateralCancelledSuccess: 'Successfully cancelled collaretal!',

    // Branch
    BranchCreateNewRegionSuccess: 'Successfully created new region!',
    BranchCreateNewBranchSuccess: 'Successfully created new branch approval!',

    BranchUpdateBranchSuccess: 'Successfully create update branch approval',
    BranchDeleteBranchSuccess: 'Successfully created delete branch approval',

    BranchUpdateRegionSuccess: 'Successfully updated region',
    BranchDeleteRegionSuccess: 'Successfully delete region',

    // Setting
    SettingUpdateSettingsSuccess: 'Successfully created update product approval!',
    SettingUpdateProductApprovalSuccess: 'Successfully approved product!',
    SettingUpdateProductRejectedSuccess: 'Successfully rejected product!',
    SettingUpdateCollateralApprovalSuccess: 'Successfully approved collateral!',
    SettingUpdateCollateralRejectedSuccess: 'Successfully rejected collateral!',

    // Admin
    AdminCreateNewRoleSuccess: 'Successfully created new role!',
    AdminEditRoleDetailsSuccess: 'Successfully updated Role details!',
    AdminDeleteRoleSuccess: 'Successfully deleted role!',
    AdminCreateNewAdminSuccess: 'Successfully created new admin!',
    AdminEditAdminDetailsSuccess: 'Successfully updated Admin details!',
    AdminDeleteAdminSuccess: 'Successfully deleted admin!',

    // Approval
    ApprovalApproveTransactionSuccess: 'Successfully approved transaction!',
    ApprovalRejectTransactionSuccess: 'Successfully rejected transaction!',

    ApprovalApproveProjectSuccess: 'Successfully approved project!',
    ApprovalRejectProjectSuccess: 'Successfully rejected project!',

    ApprovalApproveTransferSuccess: 'Successfully approved transfer!',
    ApprovalPendingTransferSuccess: 'Successfully pending received transfer!',
    ApprovalRejectTransferSuccess: 'Successfully rejected transfer!',

    ApprovalApproveReleaseEarmarkSuccess: 'Successfully approved release earmark!',
    ApprovalRejectReleaseEarmarkSuccess: 'Successfully rejected release earmark!',

    ApprovalApproveBranchSuccess: 'Successfully approved branch!',
    ApprovalRejectBranchSuccess: 'Successfully rejected branch!',

    ApprovalApproveGoldConversionSuccess: 'Successfully approved branch!',
    ApprovalRejectGoldConversionSuccess: 'Successfully rejected branch!',

    // Project
    ProjectCreateNewProjectSuccess: 'Successfully created new project!',
    ProjectEditProjectDetailsSuccess: 'Successfully updated project details!',
};

export const GoldSilverInventoryTabs = [
    {
        label: 'Emas-I',
        value: GoldSilverInventorySelectedTab.GoldIslamicPhysical,
    },
    {
        label: 'Emas Account-I',
        value: GoldSilverInventorySelectedTab.GoldIslamicPaper,
    },
    {
        label: 'Precious Metal Physical',
        value: GoldSilverInventorySelectedTab.GoldConventionalPhysical,
    },
    {
        label: 'Precious Metal Account',
        value: GoldSilverInventorySelectedTab.GoldConventionalPaper,
    },
    {
        label: 'Physical Islamic Silver',
        value: GoldSilverInventorySelectedTab.SilverIslamicPhysical,
    },
    {
        label: 'Paper Islamic Silver',
        value: GoldSilverInventorySelectedTab.SilverIslamicPaper,
    },
    {
        label: 'Physical Conventional Silver',
        value: GoldSilverInventorySelectedTab.SilverConventionalPhysical,
    },
    {
        label: 'Paper Conventional Silver',
        value: GoldSilverInventorySelectedTab.SilverConventionalPaper,
    },
];

export const ReportsGoldSilverInventoryTabs = [
    {
        label: 'Branch Inventory',
        value: ReportsGoldInventorySelectedTab.BranchInventory,
    },
    {
        label: 'Gold Inventory Delivered',
        value: ReportsGoldInventorySelectedTab.InventoryDelivered,
    },
    {
        label: 'Gold Inventory Received',
        value: ReportsGoldInventorySelectedTab.InventoryReceived,
    },
];

export const SilverInventoryTabs = [
    {
        label: 'Physical Islamic Silver',
        value: SilverInventorySelectedTab.IslamicPhysical,
    },
    {
        label: 'Paper Islamic Silver',
        value: SilverInventorySelectedTab.IslamicPaper,
    },
    {
        label: 'Physical Conventional Silver',
        value: SilverInventorySelectedTab.ConventionalPhysical,
    },
    {
        label: 'Paper Conventional Silver',
        value: SilverInventorySelectedTab.ConventionalPaper,
    },
];

export const ModulePermissions = {
    [ModuleEnum.Dashboard]: [View, Edit],
    [ModuleEnum.CustomerManagement]: [View, Create, Edit],
    [ModuleEnum.Product]: [View, Create, Edit],
    [ModuleEnum.BuySellGold]: [View, Create, Edit],
    [ModuleEnum.Conversion]: [View, Create],
    [ModuleEnum.Approval]: [View, Edit],
    [ModuleEnum.BranchManagement]: [View, Create, Edit],
    [ModuleEnum.RBAC]: [View, Create, Edit],
    [ModuleEnum.Inventory]: [View, Create],
    [ModuleEnum.InventoryTransaction]: [View, Edit],
    [ModuleEnum.Discount]: [View, Create, Edit],
    [ModuleEnum.InventoryTransfer]: [View, Create],
    [ModuleEnum.Setting]: [View, Edit],
    [ModuleEnum.Report]: [View],
    [ModuleEnum.Project]: [View, Create, Edit],
    [ModuleEnum.Collateral]: [View, Create, Edit],
    [ModuleEnum.MarketStatus]: [View, Edit],
    [ModuleEnum.CustomerTransfer]: [View, Create, Edit],
    [ModuleEnum.StockOut]: [View, Create, Edit],
};

export const invalidModules = [
    ModuleEnum.Collateral,
    ModuleEnum.CustomerTransfer,
    ModuleEnum.Setting,
    ModuleEnum.Report,
];
